module.exports = __webpack_public_path__ + "img/house-4.83ee1d1e.jpeg";